import { useSelector } from 'react-redux';
import { selectSurgerySegments, selectIssueDesc, selectSurgeryDate } from '@store/order/selectors';



const SurgeryInfo = (): JSX.Element => {

	const surgerySegments = useSelector(selectSurgerySegments);
	const issueDesc = useSelector(selectIssueDesc);
	const surgeryDate = useSelector(selectSurgeryDate);

	return (
		<>
			{surgerySegments && surgerySegments.length > 0 &&
				<div className='order-summary-element'>

					<h2>Vyznačená místa potíží</h2>

					<div className='summary-property'>
						<p>{surgerySegments.join(', ')}</p>
					</div>

				</div>}
			
			
			{issueDesc && issueDesc.length > 0 &&
				<div className='order-summary-element'>

					<h2>Popis zranění</h2>

					<div className='summary-property'>
						<p>{issueDesc ? issueDesc : '-'}</p>
					</div>

				</div>}


			<div className='order-summary-element'>

				<h2>Termín zákroku / kdy límec potřebuji</h2>

				<div className='summary-property'>
					<p>{surgeryDate ? new Intl.DateTimeFormat('cs-CZ').format(new Date(surgeryDate)) : '-'}</p>
				</div>

			</div>
		</>
	);
};

export default SurgeryInfo;